<template>
  <!-- v-if="
    component != null && component.properties != null && component.type != null
  "-->
  <LargeCard
    v-if="component.type == 'large-card'"
    class
    :properties="component.properties"
    :image_contained="image_contained"
  />
  <ImageCard
    v-else-if="component.type == 'image-card'"
    class
    :properties="component.properties"
    :image_contained="false"
  />
  <SimpleImage
    v-else-if="component.type == 'simple-image'"
    class
    :properties="component.properties"
    :image_contained="false"
  />
  <SmallCenterCard
    v-else-if="component.type == 'small-centered-card'"
    class
    :properties="component.properties"
    :image_contained="image_contained"
  />
  <SmallLeftCard
    v-else-if="component.type == 'small-left-card'"
    class
    :properties="component.properties"
    :image_contained="image_contained"
  />
  <CompactCard
    v-else-if="component.type == 'small-compact-card'"
    class
    :properties="component.properties"
    :image_contained="image_contained"
  />
  <Drawer
    v-else-if="component.type == 'drawer'"
    :properties="component.properties"
  />
</template>

<script>
export default {
  name: "FactoryComponent",
  components: {
    LargeCard: () =>
      /* webpackChunkName: "comp-[request]" */ import("./Components/LargeCard"),
    ImageCard: () =>
      /* webpackChunkName: "comp-[request]" */ import("./Components/ImageCard"),
    SimpleImage: () =>
      /* webpackChunkName: "comp-[request]" */ import(
        "./Components/SimpleImage"
      ),
    SmallLeftCard: () =>
      /* webpackChunkName: "comp-[request]" */ import(
        "./Components/SmallLeftCard"
      ),
    SmallCenterCard: () =>
      /* webpackChunkName: "comp-[request]" */ import(
        "./Components/SmallCenteredCard"
      ),
    CompactCard: () =>
      /* webpackChunkName: "comp-[request]" */ import(
        "./Components/CompactCard"
      ),
    Drawer: () =>
      /* webpackChunkName: "comp-[request]" */ import("./Components/Drawer")
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    component: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: true
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  }
};
</script>
